import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import './BlogList.css';

const BlogList = () => {
  const API = process.env.REACT_APP_BACKEND_URL;
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get(`${API}/api/wordpress/posts`);
      setPosts(response.data.posts);
    } catch (error) {
      console.error('Error fetching blog posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    // WordPress RSS returns RFC 2822 format (e.g., "Wed, 26 Mar 2025 12:00:00 +0000")
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  if (loading) {
    return (
      <div className="blog-list-container">
        <div className="container">
          <div className="blog-loading">Loading articles...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-list-container">
      <div className="container">
        <div className="blog-header">
          <h1 className="heading-1">Our Blog</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginTop: '1rem' }}>
            Fresh insights, growing tips, and health benefits of microgreens
          </p>
        </div>

        {posts.length === 0 ? (
          <div className="no-posts">
            <p>No blog posts available yet. Check back soon!</p>
          </div>
        ) : (
          <div className="blog-grid">
            {posts.map((post, index) => (
              <article key={index} className="blog-card">
                <Link to={`/blog/${post.slug}`} className="blog-card-link">
                  {post.featured_image && (
                    <div className="blog-card-image">
                      <img src={post.featured_image} alt={post.title} />
                    </div>
                  )}
                  <div className="blog-card-content">
                    <div className="blog-meta">
                      <span className="blog-date">
                        <Calendar size={16} />
                        {formatDate(post.published_date)}
                      </span>
                      <span className="blog-author">
                        By {post.author}
                      </span>
                    </div>
                    <h2 className="heading-3">{post.title}</h2>
                    <p className="body-medium blog-excerpt">{post.excerpt}</p>
                    <div className="blog-read-more">
                      <span>Read More</span>
                      <ArrowRight size={18} />
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogList;
